export default {
    backend: 'https://tg-api.vovcheg.ru',
};



// WEBPACK FOOTER //
// ./src/config.js